import { Box, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface Props {
    title: string;
    /** Optional element to show at the end of the header (e.g. edit button). */
    rightElement?: ReactNode;
}

export default function GlobalHeader(props: Props) {
    const { title, rightElement } = props;
    return (
        <Stack
            direction="row"
            sx={{
                width: '100%',
                mt: 2,
                mb: 2,
                px: 2,
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
            }}
        >
            <Typography
                variant="h3"
                sx={{
                    fontWeight: 500,
                    fontSize: '2rem',
                    letterSpacing: '-0.01em',
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                    textAlign: 'center',
                }}
            >
                {title}
            </Typography>
            {rightElement != null ? <Box sx={{ flexShrink: 0 }}>{rightElement}</Box> : null}
        </Stack>
    );
}
